import React from "react";
import { Badge, TableCell, Tooltip } from "@mui/material";
import { canalOrigenIcons, redSocialIcons } from "../ListadoSolicitud.iconMaps";

// Columna de origen: ícono del canal (idCompraEncuesta) y, en la esquina, la red
// social (idRedesSociales). Si ambos son lo mismo (ej. FACEBOOK/FACEBOOK) se
// muestra un solo ícono. Sin canal ni red → celda vacía.
export default function CeldaOrigen({ data }) {
  const canal = canalOrigenIcons[Number(data.idCompraEncuesta)];
  const red = redSocialIcons[Number(data.idRedesSociales)];

  if (!canal && !red) {
    return <TableCell align="center" />;
  }

  const mismoOrigen = canal && red && canal.clave === red.clave;
  const tooltip = [
    canal && `Canal: ${canal.label}`,
    red && `Red social: ${red.label}`,
  ].filter(Boolean).join(" · ");

  // Solo uno de los dos, o ambos iguales: un único ícono
  if (!canal || !red || mismoOrigen) {
    const unico = canal || red;
    return (
      <TableCell align="center">
        <Tooltip title={tooltip} arrow placement="top">
          <span style={{ display: "inline-flex" }}>{unico.icon(22)}</span>
        </Tooltip>
      </TableCell>
    );
  }

  return (
    <TableCell align="center">
      <Tooltip title={tooltip} arrow placement="top">
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          badgeContent={
            <span
              style={{
                display: "inline-flex",
                background: "white",
                borderRadius: "50%",
                padding: 1,
                boxShadow: "0 0 0 1px #e2e8f0",
              }}
            >
              {red.icon(11)}
            </span>
          }
        >
          <span style={{ display: "inline-flex" }}>{canal.icon(22)}</span>
        </Badge>
      </Tooltip>
    </TableCell>
  );
}
